import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Course from "../pages/course/page";
import Certificate from "../pages/certificate/page";
import Tarot from "../pages/tarot/page";
import CoursesPage from "../pages/courses/page";
import MembershipPage from "../pages/membership/page";
import AcademyPage from "../pages/academy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/courses",
    element: <CoursesPage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/academy",
    element: <AcademyPage />,
  },
  {
    path: "/course/:id",
    element: <Course />,
  },
  {
    path: "/certificate",
    element: <Certificate />,
  },
  {
    path: "/tarot",
    element: <Tarot />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
